// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
import App from './App'
import router from './router'
import Axios from 'axios'
import wx from 'weixin-js-sdk'
import api from './api/index.js'
import apiSpecial from './api/indexSpecial.js'


import 'amfe-flexible'
// var Less = require('Less');
require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.config.productionTip = false
import { Lazyload } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true
});

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Axios.defaults.headers.post['Content-Type'] = 'Access-Control-Allow-Headers';

Vue.prototype.$axios = Axios
Vue.prototype.$wx = wx

Vue.prototype.$api = api
Vue.prototype.$apiSpecial = apiSpecial


import Vuex from 'vuex';

Vue.use(Vuex);
var store = new Vuex.Store({
  //存储状态
  state: {
    userInfo:null,
    mobile:'',
    details:null
  },
  //显示的更改state
  mutation: {

  },
  //过滤state中的数据
  getters: {},
  //异步操作
  actions: {}
});
Vue.prototype.$store = store
export default store

//在页面加载时读取sessionStorage里的状态信息
if (sessionStorage.getItem("store")) {
  store.replaceState(
    Object.assign(
      {},
      store.state,
      JSON.parse(sessionStorage.getItem("store"))
    )
  );
}

//在页面刷新时将vuex里的信息保存到sessionStorage里
window.addEventListener("beforeunload", () => {
  sessionStorage.setItem("store", JSON.stringify(store.state));
});

window.addEventListener('pagehide', () => {
    sessionStorage.setItem('store', JSON.stringify(store.state))
})

// let that = new Vue({
// 	router,
// 	template: `
// 		<router-view></router-view>
// 		`
// }).$mount("#app");
// export default Vue
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js